import { ProductManagementSubscriptionsSubheader } from "features/subscriptionManagement/ProductManagementSubscriptionsSubheader";
import { Outlet } from "react-router";
import "style/discoverPage.css";

export function ProductManagementSubscriptionsLayoutPage() {
	return (
		<div className="discover-layout">
			<ProductManagementSubscriptionsSubheader />
			<Outlet />
		</div>
	);
}
